module.exports = __webpack_public_path__ + "media/images/smart_phone/item/btn_confirm-c2904931d56e9ac5fd0488a55083b22b.png";